<template>
  <ListItemWideHighlighted class="list-item" :title="event.title" :action-url="actionUrlWithParams"
                           :description="event.description" :image-url="event.imageUrl"
                           :color-index="colorIndexForType('event')">
    <template #icon>
      <DateIcon :date="event.startAt" />
    </template>
    <template #content>
      <event-list-item-wide-content :event="event" />
    </template>
    <template #action-button-text>
      {{ i18n.t('public.events.rsvp') }}
    </template>
  </ListItemWideHighlighted>
</template>

<script>
import ListItemWideHighlighted from './list-item-wide-highlighted'
import EventListItemWideContent from './event-list-item-wide-content'
import DateIcon from './date-icon'
import { actionUrlWithParamsMixin } from './action-url-with-params'
import { sharedEventListItemMixin } from './shared-event-list-item'

export default {
  components: { DateIcon, EventListItemWideContent, ListItemWideHighlighted },

  mixins: [ actionUrlWithParamsMixin, sharedEventListItemMixin ]
}
</script>

<style lang="scss" scoped>
.list-item {
  background-color: #ECECEC;
}
</style>
